module.exports = __webpack_public_path__ + "assets/36f1b2c268c169962585f768b29e0937.mp3";